import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Link,
  useTheme,
  useMediaQuery
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const TermsDialog = ({ open, onClose }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      fullScreen={fullScreen}
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: 2,
          backgroundImage: 'url(/assets/about.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          overflow: 'hidden'
        }
      }}
    >
      <Box sx={{ 
        backgroundColor: 'rgba(255,255,255,0.95)', 
        px: 3, 
        py: { xs: 2, md: 3 },
        m: { xs: 0, md: 2 },
        borderRadius: { xs: 0, md: 2 },
        maxWidth: { md: 600 },
        mx: 'auto'
      }}>
        <DialogTitle 
          sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            pb: 1
          }}
        >
          <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold' }}>
            Terms of Use
          </Typography>
          <Button 
            onClick={onClose} 
            color="inherit" 
            size="small"
            sx={{ minWidth: 0, p: 0.5 }}
          >
            <CloseIcon />
          </Button>
        </DialogTitle>
        
        <DialogContent sx={{ py: 0 }}>
          <Typography variant="body1" paragraph>
            The website is not responsible for the quality or validity of the offers mentioned. The offer provided in the business establishment itself is the binding offer and the price and offering listed on this website are not constraining in any way.
          </Typography>
          
          <Typography variant="body1" paragraph>
            It is recommended to call before arriving to both reserve seats and verify the validity of the deal.
          </Typography>
          
          <Typography variant="body1" paragraph>
            The use of the business photos is done for the sole purpose of promoting those businesses and Happy Hours TLV does not own or manage any of the copyrights to these images.
          </Typography>
          
          <Typography variant="body1">
            For the full terms of service, please visit:
          </Typography>
          
          <Box sx={{ my: 2 }}>
            <Link 
              href="https://www.happyhourstlv.com/tos.html" 
              target="_blank"
              rel="noopener noreferrer"
              underline="hover" 
              color="primary"
            >
              Full Terms of Service
            </Link>
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ justifyContent: 'center', pt: 2 }}>
          <Button 
            onClick={onClose} 
            variant="contained" 
            color="primary"
          >
            Accept
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default TermsDialog;